import {
  BrokeredOrderStatus,
  enumBrokeredOrderStatus,
  enumQuoteStatus,
  QuoteStatus,
} from '@rematter/frontend-lib-api-client';
import { ThemeColor } from '@rematter/ui-web';

export const colorByBrokeOrderStatus: Record<BrokeredOrderStatus, ThemeColor> =
  {
    [enumBrokeredOrderStatus.Closed]: 'success',
    [enumBrokeredOrderStatus.Draft]: 'neutral',
    [enumBrokeredOrderStatus.Fulfilled]: 'primary',
    [enumBrokeredOrderStatus.InProgress]: 'primary',
    [enumBrokeredOrderStatus.Open]: 'primary',
    [enumBrokeredOrderStatus.Voided]: 'failure',
  };

export const colorByQuoteStatus: Record<QuoteStatus, ThemeColor> = {
  [enumQuoteStatus.Accepted]: 'success',
  [enumQuoteStatus.Converted]: 'primary',
  [enumQuoteStatus.Draft]: 'neutral',
  [enumQuoteStatus.Expired]: 'failure',
  [enumQuoteStatus.Rejected]: 'failure',
  [enumQuoteStatus.Sent]: 'warning',
  [enumQuoteStatus.Voided]: 'failure',
};
